import cx from "classnames";
import { SmallDoubleDownArrow } from "components/icons/SmallDoubleDownArrow";

export const SCROLL_HINT_VARIANT = {
  DEFAULT: "default",
  COMPACT: "compact",
} as const;

export type ScrollHintVariant =
  (typeof SCROLL_HINT_VARIANT)[keyof typeof SCROLL_HINT_VARIANT];

type ScrollListHintProps = {
  className?: string;
  onClick?: () => void;
  variant?: ScrollHintVariant;
};

export const ScrollListHint = ({
  className,
  onClick,
  variant = SCROLL_HINT_VARIANT.DEFAULT,
}: ScrollListHintProps) => {
  const isCompact = variant === SCROLL_HINT_VARIANT.COMPACT;

  const rootClassName = cx(
    "scroll-list-fade t-pointer-events-none t-absolute t-inset-x-0 t-bottom-0 t-flex t-flex-col t-justify-end",
    isCompact ? "t-h-10 t-pb-2.5" : "t-h-[72px]",
    className
  );

  return (
    <div className={rootClassName}>
      <button
        type="button"
        onClick={onClick}
        className="all:unset t-pointer-events-auto t-mx-auto t-flex t-cursor-pointer t-items-center t-gap-1 t-text-body-sm t-text-text-30"
      >
        Scroll to view full list
        <SmallDoubleDownArrow className="t-text-text-30" />
      </button>
    </div>
  );
};
